import { useQueryClient } from "@tanstack/react-query";

const useCleanupDashboardContext = () => {
  const queryClient = useQueryClient();

  return (id) => {
    queryClient.invalidateQueries(['nexa-gen-dash', id]);
    queryClient.invalidateQueries(['temp-dashboard', id]);
  }

};

export default useCleanupDashboardContext;
